import { ButtonLoading } from "../../../../components/buttons/button-loading";

const TEXT_MODAL_OPCION_1 = {
  option: "Opción 1",
  title: "Crea una evaluación con un cargo existente",
  description:
  'Selecciona uno de los cargos pre-cargados con perfiles y competencias ya definidas. Invita colaboradores para participar de este proceso de evaluación',
};

const TEXT_MODAL_OPCION_2 = {
  option: "Opción 2",
  title: "Crea una evaluación con un cargo nuevo",
  description:
    "Crea el cargo, selecciona el perfil y las competencias asociadas. Selecciona y crea nuevos colaboradores para responder la evaluación y participar del proceso.",
};
const ModeSelectionProcess = (props) => {
  const { setSteps, steps, setCreateProcess} = props;

  return (
    <div className="gm-modal-selection-process">
      <div className="gm-modal-option-selection">
        <span>{TEXT_MODAL_OPCION_1.option}</span>
        <h3>{TEXT_MODAL_OPCION_1.title}</h3>
        <p>{TEXT_MODAL_OPCION_1.description}</p>
        <div>
        <div className="gm-modal-option-button">
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Continuar"
              onClick={()=>{
                setSteps(1);
                setCreateProcess(true)
              }}
            />
          </div>
        </div>
      </div>

      <div className="gm-modal-option-selection">
        <span>{TEXT_MODAL_OPCION_2.option}</span>
        <h3>{TEXT_MODAL_OPCION_2.title}</h3>
        <p>{TEXT_MODAL_OPCION_2.description}</p>
        <div>
        <div className="gm-modal-option-button">
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Continuar"
              onClick={()=>{
                setSteps(1);
                setCreateProcess(false)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeSelectionProcess;